module.exports = __webpack_public_path__ + "img/logo_bg_TM.b2a19203.png";